<template>
  <div>
    <sl-table :enable-pager="false" :columns="columns" :data="datas"></sl-table>
    <Button icon="ios-add" type="dashed" @click="handleAdd">添加</Button>
    <Modal title="题型结构" :loading="true" v-model="modalVisible" :mask-closable="false">
      <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="90">
        <FormItem label="题型" prop="type">
          <sl-select v-model="form.type" type="radio" dict="$questionType"></sl-select>
        </FormItem>
        <FormItem label="数量" prop="totalNum">
          <InputNumber :step="1" :min="1" placeholder="请输入数量" v-model="form.totalNum"></InputNumber>
        </FormItem>
        <FormItem label="分值" prop="score">
          <InputNumber placeholder="请输入每题分值" v-model="form.score"></InputNumber>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import { conv } from '@/util/index'

const questionType = (v) => conv(v, '$questionType')


export default {
  data() {
    return {
      columns: [{
          title: '题型',
          render: (h, params) => {
            return h('span', questionType(params.row.type))
          }
        },
        {
          title: '数量',
          key: 'totalNum'
        },
        {
          title: '分值',
          key: 'score'
        },

        {
          title: '操作',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let acts = [
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.edit(params)
                  }
                }
              }, '编辑'),
              h('a', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.remove(params)
                  }
                }
              }, '删除')
            ]
            return h('div', acts)
          }
        }
      ],
      modalVisible: false,
      rules: {
        type: [{ required: true, type: 'number', message: '请选择题型', trigger: 'blur,change' }],
        totalNum: [{ required: true, type: 'number', message: '数量不能为空', trigger: 'blur,change' }],
        score: [{ type: 'number', required: true, message: '分值不能为空', trigger: 'blur,change' }],
      },
      form: {
        type: null,
        totalNum: null,
        score: null
      },
      datas: [],
      editRow: -1,
      loading: false
    }
  },

  props: {
    data: {
      type: Array
    }
  },

  created() {
    if (this.data) {
      this.init()
    }
  },

  watch: {
    data() {
      this.init(this.data)
    }
  },
  methods: {
    init(data) {
      if( Array.isArray(data) )
        this.datas = data
    },

    edit({ row, index }) {
      this.modalVisible = true
      this.$utils.fill(this.form, row)
      this.editRow = index
    },

    remove({ row }) {
      let index = this.datas.findIndex(i => i.questionType == row.questionType)
      if (index >= 0) {
        this.datas.splice(index, 1)
      }
    },

    save() {
      if (this.editRow >= 0) {
        this.datas.splice(this.editRow,1,{ ...this.form })
      } else {
        this.datas.push({ ...this.form })
      }
      this.$emit('on-update', this.datas)
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.modalVisible = false
          this.save()
        } else {
          this.$Message.error('参数错误')
        }
      })
    },

    handleAdd() {
      this.editRow = -1
      this.modalVisible = true
      this.$utils.fill(this.form, {})
    }

  }
}

</script>
